import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';
export default function ActiveInterviewsTableGraph() {
  return (
    <Paper sx={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="subtitle2"
          padding={1}
          textAlign="center"
          fontWeight={600}
          component="div"
        >
          {
            'Active Interviews element has been removed. Head to Home > Interviews > Upcoming to see this info'
          }
        </Typography>
      </div>
    </Paper>
  );
}
